import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guard/auth.guard';
import { AlmacenInsumosComponent } from './almacen-insumos.component';
import { EgresoComponent } from './egreso/egreso.component';
import { IngresoComponent } from './ingreso/ingreso.component';
import { InventarioComponent } from './inventario/inventario.component';
import { KardexComponent } from './kardex/kardex.component';

const routes: Routes = [
  {
    path: '',
    component: AlmacenInsumosComponent,
    children: [
      {
        title: 'AYB - Almacén - Inventario',
        path: 'ingresos',
        canActivate: [AuthGuard],
        component: InventarioComponent,
      },
      {
        title: 'AYB - Almacén - Agregar Ingreso',
        path: 'ingresos/nuevo',
        canActivate: [AuthGuard],
        component: IngresoComponent,
      },
      {
        title: 'AYB - Almacén - Modificar Ingreso',
        path: 'ingresos/:id',
        canActivate: [AuthGuard],
        component: IngresoComponent,
      },
      {
        title: 'AYB - Almacén - Egresos',
        path: 'egresos',
        canActivate: [AuthGuard],
        component: EgresoComponent,
      },
      {
        title: 'AYB - Almacén - Kardex de Insumos',
        path: 'kardex',
        canActivate: [AuthGuard],
        component: KardexComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AlmacenInsumosRoutingModule {}
